import { Text } from '@simplywallst/ui-core';
import { TooltipTable } from './styled';

type TooltipDataItem = {
  title?: string | null;
  value?: string | null;
  ratio?: string | null;
  holdingsText?: string | null;
  valueColor?: 'good' | 'bad' | 'warning' | null;
};

type TooltipData = TooltipDataItem[];

export const DividendQualityForecastTooltip = () => {
  const data: TooltipData = [
    {
      title: 'Next 12m Total',
      value: 'AU$1201.42',
    },
    {
      title: 'Low score 0-2',
      value: 'AU$280',
      ratio: '9%',
      holdingsText: '5 holdings',
      valueColor: 'bad',
    },
    {
      title: 'Medium score 3-4',
      value: 'AU$2800',
      ratio: '19%',
      holdingsText: '1 holding',
      valueColor: 'warning',
    },
    {
      title: 'High score 5-6',
      value: 'AU$280',
      ratio: '9%',
      holdingsText: '0 holdings',
      valueColor: 'good',
    },
  ];

  return (
    <TooltipTable>
      <tbody>
        {data.map((item, index) => (
          <tr key={index}>
            <td>
              {item.title && (
                <Text typography="tinyStrong" color="textSolid">
                  {item.title}
                </Text>
              )}
            </td>
            <td>
              {item.value && (
                <Text
                  typography="tinyStrong"
                  color={item.valueColor ?? 'textSolid'}
                >
                  {item.value}
                </Text>
              )}
            </td>
            <td>
              {item.ratio && (
                <Text
                  typography="tinyStrong"
                  color={item.valueColor ?? 'textSolid'}
                >
                  {item.ratio}
                </Text>
              )}
            </td>
            <td>
              {item.holdingsText && (
                <Text typography="tiny" color="textSoft">
                  {item.holdingsText}
                </Text>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </TooltipTable>
  );
};
